(function () {
    'use strict';

    //cool shortcuts like key combinations are not supported
    //unless a need arises, they will not be implemented

    angular.module('core')
        .service('KeypressService', ['$rootScope', '$document', function ($rootScope, $document) {

            $rootScope.listeners = [];
            $rootScope.lastId = 0;

            $rootScope.idExists = function (id) {//return the index+1 of object with id equal to argument
                for (var i = 0; i < $rootScope.listeners.length; i++) {//so that if an object was found
                    if ($rootScope.listeners[i].id === id)//the returned value would always be >0,
                        return i + 1;//thus enabling the return value to be used as a boolean
                }
                return 0;
            };

            $document.bind('keydown', function (event) {//pass event and listener id to on event callback
                for (var i = 0; i < $rootScope.listeners.length; i++) {//id is passed, so that one-time eventListeners could unregister themselves.
                    if ($rootScope.listeners[i].keyCode == event.keyCode) {
                        $rootScope.listeners[i].callback(event, $rootScope.listeners[i].id);
                    }
                }
            });

            return {
                registerKeypressListener: function (keycode, callback) {
                    var listener = {};
                    if ($rootScope.listeners.length === 0) {
                        listener.id = 0;
                        $rootScope.lastId = 0;
                    }
                    else listener.id = $rootScope.lastId++;
                    listener.keyCode = keycode;
                    listener.callback = callback;
                    $rootScope.listeners.push(listener);
                    return listener.id;

                },
                unregisterKeypressListener: function (id) {
                    var index = $rootScope.idExists(id);
                    if (index) {
                        $rootScope.listeners.splice(index - 1, 1);
                        return true;
                    }
                    else //no such listener
                    {
                        return false;
                    }
                }
            };
        }]);

})();
